export const VictoryIcon = () => {
  return (
    <svg
      width="57"
      height="57"
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.95557"
        y="4.48389"
        width="48.012"
        height="48.012"
        rx="24.006"
        fill="#D1FADF"
      />
      <rect
        x="4.95557"
        y="4.48389"
        width="48.012"
        height="48.012"
        rx="24.006"
        stroke="#ECFDF3"
        strokeWidth="8.00201"
      />
      <path
        d="M38.9645 27.5697V28.4899C38.9633 30.6469 38.2648 32.7457 36.9733 34.4732C35.6818 36.2008 33.8665 37.4647 31.798 38.0762C29.7296 38.6878 27.5189 38.6144 25.4956 37.8669C23.4723 37.1194 21.7448 35.7378 20.5708 33.9284C19.3968 32.1189 18.8392 29.9784 18.9812 27.8261C19.1231 25.6738 19.9569 23.625 21.3584 21.9854C22.7598 20.3457 24.6537 19.203 26.7576 18.7276C28.8615 18.2523 31.0628 18.4697 33.033 19.3476M38.9645 20.4879L28.962 30.5004L25.9612 27.4997"
        stroke="#039855"
        strokeWidth="2.0005"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

